import {IComponentOptions} from 'angular';
import {IStateService} from 'angular-ui-router';
import ErrorService from '../../../core/errors/service/ErrorService';
import BenutzerRS from '../../../core/service/BenutzerRS.rest';
import PasswordStrengthService from '../../../core/service/PasswordStrengthService';
import RoleUtilService from '../../../core/service/RoleUtilService';
import AbstractGesuchViewController from '../../../gesuch/component/abstractModelController';
import {rolePrefix, TSRole} from '../../../models/enums/TSRole';
import TSBenutzer from '../../../models/TSBenutzer';
import TSPasswordData from '../../../models/TSPasswordData';
import {IAnlaufstelleBenutzerEditStateParams} from '../../benutzerverwaltung.route';
import ILogService = angular.ILogService;
import IScope = angular.IScope;
import IWindowService = angular.IWindowService;
import ITranslateService = angular.translate.ITranslateService;

let template = require('./benutzerProfilView.html');

export class BenutzerProfilViewComponentConfig implements IComponentOptions {
    transclude: boolean = false;
    template: string = template;
    controller: any = BenutzerProfilViewViewController;
    controllerAs: string = 'vm';
    bindings: any = {
        benutzer: '<',
        forcePasswordChange: '<',
        noEmailEntry: '<',
        phoneRequired: '<?', //damit man einstellen kann ob phone ein Pflichtfeld ist
    };
}

export class BenutzerProfilViewViewController extends AbstractGesuchViewController<TSBenutzer> {

    private benutzer: TSBenutzer;

    private viewReadonly: boolean = false;
    private passwordChangeInitialized: boolean;

    forcePasswordChange: boolean;
    noEmailEntry: boolean = false;
    phoneRequired: boolean = false;

    static $inject: string[] = ['$stateParams', '$log', 'ErrorService', '$window', '$state',
        'PasswordStrengthService', '$scope', 'RoleUtilService', '$translate', 'BenutzerRS'];

    /* @ngInject */
    constructor(private $stateParams: IAnlaufstelleBenutzerEditStateParams,
                private $log: ILogService, private errorService: ErrorService,
                private $window: IWindowService, private $state: IStateService,
                private passwordStrengthService: PasswordStrengthService, $scope: IScope,
                private roleUtilService: RoleUtilService, private $translate: ITranslateService,
                private benutzerRS: BenutzerRS) {

        super($scope);

    }

    $onInit() {
        super.$onInit();
        if (this.forcePasswordChange === undefined) {
            this.forcePasswordChange = false;
        }
        this.initModel();

    }

    private initModel() {
        this.initialModel = this.benutzer;
        this.model = angular.copy(this.benutzer);
        if (this.forcePasswordChange === true) {  // simulate click
            this.onChangePasswd(null);
        }
    }

    public submit() {
        let passwordValid = this.checkPassword();
        if (this.form.$valid && this.getModel() && this.checkEmailRepeated() && passwordValid) {
            // wenn forcePasswordChange gesetzt ist hanelt es sich um einen neu eigeladenen user
            this.benutzerRS.updateOwnUser(this.model, this.forcePasswordChange).then((storedBenutzer: TSBenutzer) => {
                if (storedBenutzer !== undefined) {
                    if (this.getModel().isNew()) {
                        // this.benutzer.passwordData = new TSPasswordData(this.benutzer.email);
                        const msgKey: string = this.forcePasswordChange ? 'BENUTZER_CREATED_SUCCESS' : 'BENUTZER_REC_SUCCESS';
                        this.errorService.addMesageAsInfoWithArgs(msgKey, this.benutzer.email);
                    } else {
                        if (this.getModel().email !== storedBenutzer.email) {
                            this.errorService.addMesageAsInfoWithArgs('BENUTZER_UPDATE_EMAIL_INFO', this.benutzer.email);
                        }
                    }
                    this.benutzer = storedBenutzer;
                    this.initModel();
                    this.form.$setPristine();
                    this.form.$setUntouched();
                    this.$state.go('start');
                } else {
                    this.$log.error('could not save new benutzer ' + this.getModel());
                }

            });

        } else {
            this.$log.debug('Form was not valid');
        }

    }

    public cancelBenutzeredit() {
        this.model = angular.copy(this.initialModel);
        this.form.$setPristine();
        this.$state.go('start')

    }

    public getRoles(): Array<TSRole> {
        return this.roleUtilService.getAnlaufstelleSubuserRolesOnly();

    }

    public translateRole(val: TSRole): string {
        return this.$translate.instant(rolePrefix() + val);
    }

    private checkEmailRepeated(): boolean {
        if (this.noEmailEntry) {
            return true;
        }
        let repeatValid = this.getModel().checkEmailRepeated();
        if (!repeatValid) {
            this.errorService.addMesageAsError('ERROR_EMAIL_SAME');
            return false;
        }
        return true;
    }

    private onChangePasswd(event: any) {
        this.passwordChangeInitialized = true;
        console.log('password data', this.getModel().passwordData);
        if (this.getModel().passwordData === undefined || this.getModel().passwordData === null) {
            this.getModel().passwordData = new TSPasswordData(this.getModel().email)
        }
    }

    private checkPassword(): boolean {
        if (this.passwordChangeInitialized) {
            let passwordData = this.getModel().passwordData;
            if (passwordData) {
                return this.passwordStrengthService.checkIfValid(passwordData.password, passwordData.passwordRepeat);
            }
            return false;
        }
        return true;

    }
}



// WEBPACK FOOTER //
// ./src/app/benutzerverwaltung/component/benutzerProfilViw/benutzerProfilView.ts